import {connect} from "react-redux";
import SubleagueListPanel from "../SubleagueListPanel.jsx";
import {branch, compose, renderNothing} from 'recompose'

const SubleaguesListPanelContainer = compose(
    connect(
        (state) => ({
            game: state.games.current,
            type: state.subleagues.type,
            open: state.subleagues.openList
        })
    ), branch(({open}) => !open, renderNothing)
)(SubleagueListPanel);

export default SubleaguesListPanelContainer